const ROUTES = {
  ROOT_PATH: '/',
};

const DEFAULT_CONFIGS = {
  language: 'en',
};

export { ROUTES, DEFAULT_CONFIGS };
